function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>This a react demo page hosted on CloudFlare Pages.</p>
      </header>
    </div>
  );
}

export default App;
